module.exports = __webpack_public_path__ + "static/media/send_black.48d2334a.svg";